var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Twitter - Original"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.54752 21.7506C16.6042 21.7506 21.5578 14.2473 21.5578 7.7404C21.5578 7.52728 21.5578 7.31512 21.5434 7.10392C22.507 6.40687 23.3389 5.5438 24 4.55512C23.1014 4.95352 22.148 5.21467 21.1718 5.32984C22.1998 4.71453 22.9692 3.74662 23.3366 2.60632C22.3701 3.17993 21.3126 3.58414 20.2099 3.80152C19.4675 3.0121 18.4856 2.48936 17.4162 2.3142C16.3468 2.13905 15.2494 2.32123 14.294 2.83257C13.3385 3.34391 12.5782 4.15589 12.1307 5.14287C11.6833 6.12984 11.5735 7.23678 11.8186 8.2924C9.8609 8.1942 7.94576 7.68543 6.19745 6.79912C4.44915 5.91282 2.90676 4.66878 1.6704 3.14776C1.04073 4.23175 0.847872 5.51499 1.1311 6.73618C1.41433 7.95737 2.15234 9.02471 3.19488 9.72088C2.41123 9.69792 1.64465 9.48651 0.96 9.10456V9.16696C0.960311 10.3038 1.35385 11.4056 2.07387 12.2853C2.79389 13.1651 3.79606 13.7687 4.9104 13.9938C4.18548 14.1916 3.42487 14.2205 2.68704 14.0783C3.00181 15.0566 3.61443 15.9122 4.43924 16.5253C5.26405 17.1384 6.25983 17.4784 7.28736 17.4978C6.26644 18.3003 5.09731 18.8936 3.84687 19.2438C2.59643 19.594 1.28921 19.6943 0 19.5388C2.25183 20.9838 4.87192 21.7503 7.54752 21.7468",
    fill: "#1DA1F2"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.f8cb583e04a3a297d31d0215d631c67d.svg";
export { ForwardRef as ReactComponent };